
import { FormControl } from '@angular/forms';

import { Component, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { CustomValidators } from 'ng2-validation';

import { NofeshService } from "../nofesh.service";

import { INofesh } from './../model/nofesh';
import { ITashlum } from './../model/tashlum';
import { INirsham } from './../model/nirsham';
import { INofeshUploads } from '../model/nofesh-uploads';
import { AppSettings } from "../../shared/app-settings";
import { MenuHandler } from "app/shared/menu-handler";
import { ENofeshStatus } from '../../shared/enums/enofesh-status.enum';
import { ConfigService } from 'app/shared/config.service';
import { SSL_OP_SSLEAY_080_CLIENT_DH_BUG } from 'constants';
declare var $: any;

@Component({
    moduleId: module.id,
    templateUrl: 'end-rishum.component.html'

})

export class EndRishumComponent implements OnInit {
    reservationId: number;
    //uploadsSucced: INofeshUploads[];
    uploadsNeeded: INofeshUploads[];
    uploadsNeededForPassportValidation: INofeshUploads[] = [];
    nirshamim: INirsham[];
    tashlumim: ITashlum[];
    nofesh: INofesh;
    nofesh_id: number;
    sum_tashlumim: number;
    rishumSuccess: boolean;
    is_submit: boolean;
    is_hamtana: boolean;
    is_nofesh_full: boolean;
    is_edit_mode: boolean = false;
    nofeshAgreementsFileUrl: string;
    form: FormGroup;
    returnMessage: string;
    amitim_count: number = 1;
    ms_zehut_mazmim: number;
    nofesh_tentativi: number;
    apiUrl: string = "";
    isPassportValidMoreThanSixMonths: boolean = true;
    is_full_too_many_users: boolean = false;
    isUserIsNilveInOtherReservation: boolean = false;



    constructor(private _router: Router,
        private _http: NofeshService,
        private fb: FormBuilder,
        private _configService: ConfigService) {
        this.apiUrl = _configService.getConfigPropertyByKey("apiUrl");
        this.nofeshAgreementsFileUrl = `${this.apiUrl}/UploadFiles/NofeshAgreements/`;
    }

    ngOnInit(): void {
        MenuHandler.menuHandler($(".wiz_group"), $("#li_siyum"));
        //#region Get reservetionID
        let orderNofesh = sessionStorage.getItem('order-nofesh');
        let userSelectedNofesh = JSON.parse(sessionStorage.getItem('userSelectedNofesh'));
        var payments = JSON.parse(sessionStorage.getItem('nofeshPayments'));

        if (orderNofesh == null) {
            if (userSelectedNofesh == null) {
                this._router.navigateByUrl('/nofesh');
                return;
            }
            else {
                this.nofesh_id = userSelectedNofesh.id_nofesh;
                this.ms_zehut_mazmim = JSON.parse(sessionStorage.getItem('ms_zehut_mazmin'))
                this.nirshamim = JSON.parse(sessionStorage.getItem('nirshamim'));
            }
        }
        else {
            this.reservationId = JSON.parse(orderNofesh).id_reservation;
            this.nofesh_id = JSON.parse(orderNofesh).id_nofesh;
            this.ms_zehut_mazmim = JSON.parse(orderNofesh).nirshamim[0].ms_zehut;
            this.nirshamim = JSON.parse(sessionStorage.getItem('order-nofesh')).nirshamim;

            if (this.reservationId == 0) {
                this._router.navigateByUrl('/nofesh');
                return;
            }
        }

        if (userSelectedNofesh != null && userSelectedNofesh.id_nofesh > 0) {
            this.is_edit_mode = true;
        }

        this.form = this.fb.group({
            userDeclaration: ['', [Validators.required, CustomValidators.gt(0)]],
            userResponsibility: ['', [Validators.required, CustomValidators.gt(0)]],
            lawyerDeclaration: ['', [Validators.required, CustomValidators.gt(0)]],
            smsDeclaration: ['', [Validators.required, CustomValidators.gt(0)]],
            adifutDeclaration: ['', [Validators.required, CustomValidators.gt(0)]],
            covidDeclaration: ['', [Validators.required, CustomValidators.gt(0)]],
            greenPassChul: ["", [Validators.required, CustomValidators.gt(0)]]
        });

        let amitim_count;
        var payments = JSON.parse(sessionStorage.getItem('nofeshPayments'));
        if (payments == null) {
            this._http.getNofeshPayment(this.nofesh_id)
                .subscribe(res => {
                    payments = res;
                    amitim_count = payments.nofeshPayment.filter(nirsham => nirsham.amit == 1) !== undefined ? payments.nofeshPayment.filter(nirsham => nirsham.amit == 1).length : 0;
                    if (amitim_count > 1) {
                        this.form.addControl('amitNosafDeclaration', new FormControl('', [Validators.required, CustomValidators.gt(0)]));
                    }
                    this.amitim_count = amitim_count;
                }
                );
        }
        else {
            amitim_count = payments.nofeshPayment.filter(nirsham => nirsham.amit == 1) !== undefined ? payments.nofeshPayment.filter(nirsham => nirsham.amit == 1).length : 0;
            if (amitim_count > 1) {
                this.form.addControl('amitNosafDeclaration', new FormControl('', [Validators.required, CustomValidators.gt(0)]));
            }
            this.amitim_count = amitim_count;
        }

        //#endregion

        //this.nofesh_id = JSON.parse(orderNofesh).id_nofesh;


        this._http.getNofeshUploads(this.nofesh_id)
            .subscribe(r => {
                Object.assign(this.uploadsNeededForPassportValidation, r);
                // this.uploadsNeeded = r.filter(x => {
                //     x.is_uploaded == false

                // });   

                this.uploadsNeeded = r.filter(x => x.is_uploaded == false);

                this.uploadsNeededForPassportValidation.forEach(element => {
                    if (element.doc_type == "צילום דרכון- תקף לחצי שנה") {
                        this.isPassportValidMoreThanSixMonths = false;
                    }
                });
            });


        this._http.getNofeshPayment(this.nofesh_id)
            .subscribe(res => {
                let sum: number = 0;
                this.tashlumim = res.nofeshTashlumim;
                for (let tashlum of this.tashlumim) {
                    sum += +tashlum.schum_tashlum;
                }
                this.sum_tashlumim = sum;
            }
            );

        this._http.getCurrentNofesh(this.nofesh_id)
            .subscribe(r => {
                this.nofesh = r;
                this.is_hamtana = r.nofesh_status == ENofeshStatus.Hamtana;
                this.is_nofesh_full = r.nofesh_status == ENofeshStatus.AzalHaMelay;
                this.nofesh_tentativi = r.nofesh_tentativi;

            }, error => {
                if (error.includes("401")) {
                    localStorage.removeItem("token");
                    location.reload();
                }
            }
            );

        window.scroll(0, 0);
    }

    checkIsPassportValid() {

    }

    checkHamtana(): boolean {
        if (this.nofesh.reshumim_count == this.nofesh.total_peaple)
            return true;
        if (this.nofesh.mamtinim_count > 0 && this.nofesh.mamtinim_count < this.nofesh.total_hamtana_people)
            return true;
        if (this.nofesh.reshumim_rooms_count >= this.nofesh.total_rooms && (this.nofesh.reshumim_rooms_count + this.nofesh.mamtinim_rooms_count) < (this.nofesh.total_rooms + this.nofesh.total_hamtana_room))
            return true;

        return false;
    }
    checkIsFullRishum(): boolean {
        if (this.nofesh.mamtinim_count >= this.nofesh.total_hamtana_people)
            return true;
        if ((this.nofesh.total_hamtana_room > 0) && this.nofesh.mamtinim_rooms_count >= this.nofesh.total_hamtana_room)
            return true;

        return false;
    }

    // get _nirshamim() {return this.nirshamim;}
    submit(event) {
        this._http.saveNofeshEndRishum(this.nofesh_id).subscribe(res => {
            debugger;
            if (res.status) {

                this.is_submit = true;
                this.rishumSuccess = true;
                this.returnMessage = res.returnMessage;
                this._disableCheckedCheckboxes();
                window.scrollTo(0, 0);

            }
            // else if (!res.status && res.returnMessage == "isUserIsNilveInOtherReservation") {
            //     this.is_submit = true;
            //     this.isUserIsNilveInOtherReservation = true;
            //     window.scrollTo(0, 0);
            // }
            else if (!res.status && res.isFullTooManyUsers) {
                console.log('got into status=0 and isFullTooManyUsers=0', res);
                this.is_submit = true;
                this.is_full_too_many_users = true;

            }
            else {
                this.is_submit = true;
                if (res.isFullRishum) {
                    this.is_edit_mode = false;  //must change it in order to show the message after the submit and not before,
                    this.is_nofesh_full = true;
                    this.rishumSuccess = true;
                }
                window.scrollTo(0, 0);
                // this.rishumSuccess = false;
            }
        },
            error => {

                console.log(error);
                // if (error.includes("401")) {
                //     localStorage.removeItem("token");
                //     location.reload();
                // } 

                this.is_submit = true;
                this.rishumSuccess = false;
                window.scrollTo(0, 0);
            }
        )
        // this._router.navigateByUrl('/nofesh');
    }

    print() {

        let hiddenOnPrint = document.getElementsByName("hiddenonprint");
        for (let i = 0; i < hiddenOnPrint.length; i++) {
            hiddenOnPrint[i].style.display = "none";
        }
        (<HTMLElement>document.getElementsByClassName('wiz_group')[0]).style.display = "none";
        window.print();
        for (let i = 0; i < hiddenOnPrint.length; i++) {
            hiddenOnPrint[i].style.display = "inline";
        }
        (<HTMLElement>document.getElementsByClassName('wiz_group')[0]).style.display = "inline";

    }

    menuHandler(t, id) {
        $("#menu_ul_id").find('li').removeClass("wiz-selected-step");
        $("#menu_ul_id").find(".wiz-num").removeClass("wiz-selected-num");

        id.toggleClass('wiz-selected-step');
        id.find(".wiz-num").toggleClass("wiz-selected-num");

        $(t).find('small.fa').remove()


        if ($(t).find('.wiz-selected-step').length == 0)
            return;
        var index = $(t).find('.wiz-selected-step').index();
        var amount = parseInt($(t).find('.wiz_group').data('wiz-steps'));
        if (amount <= 0)
            return;
        var colWidth = 100 / amount * 0.99;
        $(t).find('.wiz_group').append('<small class="fa fa-caret-down wiz-current-indiction" style="width:' + colWidth + '%; margin-right:' + (colWidth * (index)) + '%;"></small>');

        this._setWizardSteps();

        this.updateHeaderTitle();
    }

    _setWizardSteps() {

        var $wizGroup = $('.wiz_group');
        if (!$wizGroup || !$wizGroup.data('wiz-steps'))
            return;
        var stepsCount = parseInt($wizGroup.data('wiz-steps'));
        var $steps = $('.wiz_group>ol>li');

        if ($steps.length > 0) {
            $steps.css('width', 100 / stepsCount + '%');
            $('.wiz-current-indiction').css('width', 100 / stepsCount + '%');

            var nextStepText = $($steps[1]).find('.wiz-text').text();
            $('.next-step').attr('title', nextStepText);
        }
    }

    updateHeaderTitle() {
        var wiz_num = $(".wiz-selected-num");
        var wiz_text = $(".wiz-selected-num").next();

        if (wiz_num.text().length > 0 && wiz_text.text().length > 0) {
            var title = $("#layouHeader").attr("title")
            title = title + " שלב " + wiz_num.text() + " - " + wiz_text.text();
            $("#layouHeader").attr("title", title);
        }
        else {
            $("#layouHeader").attr("title", "עיריית תל אביב - רישום גני ילדים וחינוך יסודי");
        }
    }



    private _disableCheckedCheckboxes(): void {
        for (let controlKey in this.form.controls) {
            const control = this.form.get(controlKey) as FormControl;
            control.patchValue(0);
            control.disable();
        }
    }
}

